import { render } from "./GalleryActionsDropdown.vue?vue&type=template&id=e27201ec&scoped=true"
import script from "./GalleryActionsDropdown.vue?vue&type=script&lang=js"
export * from "./GalleryActionsDropdown.vue?vue&type=script&lang=js"

import "./GalleryActionsDropdown.vue?vue&type=style&index=0&id=e27201ec&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e27201ec"]])

export default __exports__